import { createComponent } from '@lit/react';
import React from 'react';
import { SDSSelect } from '../sds-select/sds-select';
import { SheriffEventName } from './types';

export const SDSSelectWrapper = createComponent({
	tagName: 'sds-select',
	elementClass: SDSSelect,
	react: React,
	events: {
		onChange: 'change' as SheriffEventName,
		onFocus: 'focus' as SheriffEventName,
		onBlur: 'blur' as SheriffEventName,
	},
});
